(function () {
  'use strict';

  function formatMoney(amount, currency, locale) {
    if (amount == null || String(amount).trim() === '' || !Number.isFinite(Number(amount)) || !currency) return null;
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(Number(amount) / 100);
    } catch (_) { return null; }
  }

  function formatMeasure(value, locale) {
    if (!/^\d+(?:[.,]\d+)?$/.test(String(value).trim())) return null;
    return new Intl.NumberFormat(locale, { maximumFractionDigits: 3 }).format(Number(String(value).replace(',', '.')));
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { formatMoney: formatMoney, formatMeasure: formatMeasure };
  if (typeof document === 'undefined') return;

  function initialize(form) {
    if (form.dataset.cartPresentationReady) return;
    form.dataset.cartPresentationReady = 'true';
    var queued = false;
    function update() {
      queued = false;
      if (form.dataset.location === 'header') {
        var viewport = window.visualViewport;
        var bottom = viewport ? viewport.height + viewport.offsetTop : window.innerHeight;
        var preview = document.getElementById('PBarNextFrameWrapper');
        if (preview && preview.getClientRects().length) {
          var previewBox = preview.getBoundingClientRect();
          if (previewBox.height > 0 && previewBox.top > 0 && previewBox.bottom >= bottom - 1) bottom = Math.min(bottom, previewBox.top);
        }
        var panel = form.closest('#HeaderCart');
        var anchor = panel && panel.parentElement;
        var top = anchor ? anchor.getBoundingClientRect().top + (parseFloat(getComputedStyle(panel).top) || 0) : form.getBoundingClientRect().top;
        var available = Math.max(0, bottom - top) + 'px';
        if (form.style.getPropertyValue('--cart-available-height') !== available) form.style.setProperty('--cart-available-height', available);
      }
      var locale = document.documentElement.lang || 'de';
      var items = form.querySelector('.cart__items[data-cart-subtotal]');
      var subtotal = form.querySelector('[data-subtotal]');
      var source = form.querySelector('[data-cart-money][data-currency]');
      var currency = form.dataset.cartCurrency || source && source.dataset.currency;
      if (items && subtotal && currency) {
        var formatted = formatMoney(items.dataset.cartSubtotal, currency, locale);
        if (formatted !== null && subtotal.textContent !== formatted) subtotal.textContent = formatted;
      }
      form.querySelectorAll('[data-cart-money]').forEach(function (element) {
        var formatted = formatMoney(element.dataset.cartMoney, element.dataset.currency, locale);
        if (formatted !== null && element.textContent !== formatted) element.textContent = formatted;
      });
      form.querySelectorAll('[data-cart-measure]').forEach(function (element) {
        var formatted = formatMeasure(element.dataset.cartMeasure, locale);
        if (formatted !== null && element.textContent !== formatted) element.textContent = formatted;
      });
    }
    function schedule() {
      if (!queued) { queued = true; requestAnimationFrame(update); }
    }
    new MutationObserver(schedule).observe(form, { childList: true, subtree: true });
    if (form.dataset.location === 'header') {
      document.addEventListener('CartDrawer:open', schedule);
      window.addEventListener('resize', schedule);
      window.addEventListener('scroll', schedule, { passive: true, capture: true });
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', schedule);
        window.visualViewport.addEventListener('scroll', schedule);
      }
      var header = document.getElementById('HeaderWrapper');
      var preview = document.getElementById('PBarNextFrameWrapper');
      var resize = new ResizeObserver(schedule);
      if (header) resize.observe(header);
      if (preview) resize.observe(preview);
      var section = document.getElementById('shopify-section-header');
      if (section) resize.observe(section);
      var panel = form.closest('#HeaderCart');
      if (panel) panel.addEventListener('transitionend', schedule);
    }
    schedule();
  }

  function boot() {
    document.querySelectorAll('form[data-location="header"], form[data-location="page"]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
